import React, { memo } from "react"
import Leaf from "../Leaf"
import Highlight from "../Highlight"
import KeyPassages from "../../../data/KeyPassageList.json"
import ValuePassages from "../../../data/YWAMVersesStandard.json"
import styles from "../ParaText.module.css"
import getStandardVerse from "../../../scripts/getStandardVerse"

const TableInline = memo(
  ({
    isPsalmHeader,
    versification,
    version,
    language,
    showSpheres,
    showValues,
    content,
    iIndex,
    verbViewDialog,
    newInterlinearDialog,
    newSphereViewDialog,
    newValuesDialog,
    versificationType,
    availableBooks,
    navigateToRef,
    translate,
    displayRef,
    showQA,
    showGAP,
  }) => {
    const { type, children, start, tag } = content
    const emptyLeaf = {
      text: "",
    }
      return (
        <table className={styles[tag]}>
          <tbody>
            {children.map(row => (
              <tr className={styles[row.tag]}>
                {row.children.map(cell => (
                  <td className={styles[cell.tag]}>
                    {cell.children.map((leaf, index) => {
                      const { ref, tag, note } = leaf
                      const isText = tag
                        ? tag.indexOf("v") === -1 &&
                          tag.indexOf("c") === -1 &&
                          !note
                        : !note
                      const standardVerse = versification
                        ? getStandardVerse(versification[version], ref[0])
                        : ref[0]

                      const isKeyPassage = KeyPassages[standardVerse]
                      const isValuePassage = ValuePassages[standardVerse]
                      if (
                        (!isPsalmHeader && isKeyPassage && showSpheres) ||
                        (!isPsalmHeader && isValuePassage && showValues)
                      ) {
                        return (
                          <Highlight
                            type={showSpheres ? "KeyPassage" : "ValuePassage"}
                            key={`${iIndex}${index}-Highlight`}
                            id={showSpheres ? isKeyPassage : isValuePassage}
                            isText={isText}
                            versionRef={`${language}-${version}`}
                            newSphereViewDialog={newSphereViewDialog}
                            newValuesDialog={newValuesDialog}
                          >
                            <Leaf
                              key={`${iIndex}${index}`}
                              leaf={leaf}
                              language={language}
                              version={version}
                              standardVerse={standardVerse}
                              verbViewDialog={verbViewDialog}
                              newInterlinearDialog={newInterlinearDialog}
                              newSphereViewDialog={newSphereViewDialog}
                              versificationType={versificationType}
                              availableBooks={availableBooks}
                              navigateToRef={navigateToRef}
                              translate={translate}
                              displayRef={displayRef}
                              showQA={showQA}
                              showGAP={showGAP}
                            />
                          </Highlight>
                        )
                      }
                      return (
                        <Leaf
                          key={`${iIndex}${index}`}
                          leaf={leaf}
                          language={language}
                          version={version}
                          standardVerse={standardVerse}
                          verbViewDialog={verbViewDialog}
                          newInterlinearDialog={newInterlinearDialog}
                          newSphereViewDialog={newSphereViewDialog}
                          versificationType={versificationType}
                          availableBooks={availableBooks}
                          navigateToRef={navigateToRef}
                          translate={translate}
                          displayRef={displayRef}
                          showQA={showQA}
                          showGAP={showGAP}
                        />
                      )
                    })}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )
  })

export default TableInline
